import React from 'react';
import CVInteractive from './components/CVInteractive';

function App() {
  return (
    <div className="App min-h-screen">
      <CVInteractive />
    </div>
  );
}

export default App;